import React, { useState, useEffect } from 'react';
import { Card, Table, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from "../../utils/api";
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import { mockReceiptSettings } from '../../components/Data/MockData';

function ReceiptSettingsList() {
    const [settings, setSettings] = useState([]);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/receipt-settings', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSettings(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading receipt settings');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this setting?')) {
            return;
        }
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/receipt-settings/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Setting deleted successfully');
            fetchSettings();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to delete setting');
        }
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Ticket Information' />
                <div className="row g-3 mb-3">
                    <div className="col-md-12">
                        <div className="d-flex flex-row-reverse">
                            <Link to="/accounts/receipt-settings/add" className="btn btn-primary">
                                <i className="fa fa-plus"></i> Add Ticket Information
                            </Link>
                        </div>
                    </div>
                </div>
                <Card>
                    <Card.Body>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Company Logo</th>
                                    <th>Plate Number</th>
                                    <th>Parking Time</th>                                    <th>Ticket ID</th>
                                    <th>Inquiry Number</th>
                                    <th>T&C</th>
                                    <th>Company Email</th>
                                    <th>Custom Text</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {settings.map((setting) => (
                                    <tr key={setting.id}>
                                        <td>{setting.id}</td>
                                        <td>{setting.company_logo ? 'Yes' : 'No'}</td>
                                        <td>{setting.plate_number ? 'Yes' : 'No'}</td>
                                        <td>{setting.parking_datetime ? 'Yes' : 'No'}</td>                                        <td>{setting.ticket_id ? 'Yes' : 'No'}</td>
                                        <td>{setting.inquiry_number ? 'Yes' : 'No'}</td>
                                        <td>{setting.terms_conditions ? 'Yes' : 'No'}</td>
                                        <td>{setting.company_email ? 'Yes' : 'No'}</td>
                                        <td>{setting.custom_text}</td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <EditButton
                                                    permission="receipt-settings.edit"
                                                    to={`${process.env.PUBLIC_URL}/accounts/receipt-settings/edit/${setting.id}`}
                                                    className="btn btn-outline-secondary"
                                                />
                                                <DeleteButton
                                                    permission="receipt-settings.delete"
                                                    onDelete={() => handleDelete(setting.id)}
                                                    className="btn btn-outline-danger"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default ReceiptSettingsList;